import { gql } from '@apollo/client';

export const GET_CLOSEST_ASSIGNED_EVENT_DATE = gql`
  query GetClosestAssignedEventDate($externalUserId: Int, $eventPhase: Int) {
    getClosestAssignedEventDate(externalUserId: $externalUserId, eventPhase: $eventPhase)
  }
`;
